import { useEffect } from "react";
import { toast } from "sonner";
import { useLang } from "@/context/LanguageContext";
import { storage } from "@/lib/storage";
import { likeHeaders } from "@/lib/useLikes";

const API = process.env.REACT_APP_BACKEND_URL;

/** One-time "thanks, the content you reported was removed" notice for reporters. */
export default function ReportFeedback() {
  const { t } = useLang();
  useEffect(() => {
    if (storage.get("atlas.hasReported") !== "1") return;
    fetch(`${API}/api/reviews/reports/mine`, { credentials: "include", headers: likeHeaders() })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (d?.removed > 0) toast.success(t("report_resolved"), { duration: 8000 }); })
      .catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}
